import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangContext } from "./i18n";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Metrics from "./components/Metrics";
import Publications from "./components/Publications";
import Journey from "./components/Journey";
import Chunav from "./components/Chunav";
import Awards from "./components/Awards";
import ContactForm from "./components/ContactForm";
import Contact from "./components/Contact";
import "@/App.css";

function App() {
  const [lang, setLang] = useState("en");
  useEffect(() => {
    document.title = "Dr. Abhishek Verma — Psephologist & Political Scientist | abhishekverma.pro";
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
    <div className="bg-bone text-ink min-h-screen" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Metrics />
        <Publications />
        <Journey />
        <Marquee dark />
        <Chunav />
        <Awards />
        <ContactForm />
        <Contact />
      </main>
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#0D0E12", color: "#F6F4EF", border: "1px solid rgba(246,244,239,0.15)" } }} />
    </div>
    </LangContext.Provider>
  );
}

export default App;
